import Resource from './common/resource';

class GroupsFolders extends Resource {
  path = 'bookmarks/folders';
}

export default GroupsFolders;
